import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { TfiMoreAlt } from "react-icons/tfi";
import { useSnackbar } from "notistack";
import LoadingIcon from "./LoadingIcon";
import AccessModal from "./AccessModal";
import { WorkflowApi } from "../services/WorkflowApi";
import { DatePicker, Modal } from "antd";
import { DataProcessorApi } from "../services/DataProcessorApi";
import { getEnvironmentConfig } from "../constants/CloudConstant";
import { LoadingButton } from "@mui/lab";

export default function BasicMenu({
  row,
  axios,
  type,
  userData,
  handleRefreshWorkflow,
  fetchAllWorkflows,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAccessModal, setOpenAccessModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [isRunDatePickerOpen, setIsRunDatePickerOpen] = useState(false);
  const [datePicked, setDatePicked] = useState("");
  const open = Boolean(anchorEl);

  const openDatePickerModal = () => {
    setDatePicked("");
    setIsRunDatePickerOpen(true);
  };

  const onDateChange = (date, dateString) => {
    setDatePicked(dateString);
  };

  const handleCancel = () => {
    setDatePicked("");
    setIsRunDatePickerOpen(false);
  };

  const handleClick = (row, event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Are you sure you want to delete this workflow?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteWorkflow(),
    });
  };

  const deleteWorkflow = async () => {
    try {
      const response = await WorkflowApi.deleteWorkflow(axios, row.workflow_id);
      if (response.status === 200) {
        enqueueSnackbar("Workflow Deleted", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllWorkflows();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  const handleAccessModal = () => {
    setOpenAccessModal(!openAccessModal);
  };

  const executeDataProcessor = async (datePicked) => {
    try {
      setLoading(true);

      const data = {
        workflow_id: row.workflow_id,
        userId: userData.userId,
        username: userData.username,
        cloudEnvironment: getEnvironmentConfig().cloudEnvironment,
        workflow_run_date: datePicked,
      };

      console.log(data);

      const res = await DataProcessorApi.executeDataProcessorApi(axios, data);
      if (res.status === 200) {
        enqueueSnackbar(`${row.workflow_name} is running`, {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Something went wrong`, {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setLoading(false);
      setIsRunDatePickerOpen(false);
    }
  };
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => {
          e.stopPropagation();
          handleClick(row, e);
        }}
      >
        <TfiMoreAlt />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {row.status === "approved" ? (
          <div>
            <MenuItem
              disabled={
                row.executionInfoDto.length === 0 ||
                row.executionInfoDto[0]?.runDisabled
              }
              onClick={openDatePickerModal}
            >
              Run {type}
            </MenuItem>
            <MenuItem onClick={handleRefreshWorkflow}>Refresh {type}</MenuItem>
            <MenuItem onClick={showDeleteConfirm}>Delete {type}</MenuItem>
          </div>
        ) : (
          <MenuItem onClick={showDeleteConfirm}>Delete {type}</MenuItem>
        )}
      </Menu>

      <AccessModal
        openAccessModal={openAccessModal}
        handleAccessModal={handleAccessModal}
      />

      <Modal
        centered
        footer={null}
        title={<div style={{ textAlign: "center" }}>Select Date</div>}
        width={400}
        open={isRunDatePickerOpen}
        onCancel={handleCancel}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DatePicker
            format={{ format: "YYYY/MM/DD" }}
            onChange={onDateChange}
          />
          <LoadingButton
            size="large"
            type="submit"
            variant="outlined"
            loading={loading}
            sx={{
              marginTop: "10px",
              marginRight: "7px",
              backgroundColor: "#ffffff",
              "&:hover": { backgroundColor: "#ffffff" },
              color: "#00043C",
              border: "1px solid black",
            }}
            onClick={() => executeDataProcessor(datePicked)}
            disabled={datePicked === ""}
          >
            Run
          </LoadingButton>
        </div>
      </Modal>
      {loading && <LoadingIcon />}
    </div>
  );
}
